import { getToken } from "helper/common";
import {
    CLEAR_FORM_FIELDS,
    CLEAR_FORMULA_DETAILS,
    CLEAR_FORMULA_LIST,
    FORMULA_DELETE_CONFIRMATION_CLOSE,
    FORMULA_DELETE_CONFIRMATION_OPEN,
    FORMULA_DELETE_ERROR,
    FORMULA_DELETE_ERROR_CLEAR,
    FORMULA_DELETE_PENDING,
    FORMULA_CREATE_DIALOG_CLOSE,
    FORMULA_CREATE_DIALOG_OPEN,
    FORMULA_CREATE_ERROR,
    FORMULA_CREATE_ERROR_CLEAR,
    FORMULA_CREATE_PENDING,
    FORMULA_DETAIL_PENDING,
    FORMULA_EDIT_DIALOG_CLOSE,
    FORMULA_EDIT_DIALOG_OPEN,
    FORMULA_EDIT_ERROR,
    FORMULA_EDIT_ERROR_CLEAR,
    FORMULA_EDIT_PENDING,
    FORMULA_EXPORT_ERROR,
    FORMULA_EXPORT_ERROR_CLEAR,
    FORMULA_EXPORT_PENDING,
    FORMULA_LIST_ERROR,
    FORMULA_LIST_ERROR_CLEAR,
    FORMULA_LIST_PENDING,
    SET_FORM_FIELDS,
    SET_FORMULA_DELETE_DATA,
    SET_FORMULA_DETAILS,
    SET_FORMULA_LIST,
    SET_FORMULA_FILTER_DATA,
    FORMULA_FILTER_DIALOG_CLOSE,
    FORMULA_FILTER_DIALOG_OPEN
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { encodeObjectValues } from "helper/encodeData";
import { trimmedValues } from "helper/trim";
import {
    openFormulaEditDialog,
} from "store/app/form-management/form-congifuration/actions";

//-----------------------------|| LIST ||--------------------------------------------------------
export const setFormulaList = (formulaList) => ({
    type: SET_FORMULA_LIST,
    payload: { formulaList }
});

export const clearFormulaList = () => ({
    type: CLEAR_FORMULA_LIST,
});

export const formulaListPending = () => ({
    type: FORMULA_LIST_PENDING
});

export const formulaListError = (errorMessage) => ({
    type: FORMULA_LIST_ERROR,
    payload: { errorMessage }
});

export const formulaListErrorClear = () => ({
    type: FORMULA_LIST_ERROR_CLEAR
});

export const getFormulaList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(formulaListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getFormulaList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((formulaList) => {
                dispatch(setFormulaList(formulaList));
                dispatch(formulaListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaListError(message));
                }
                else {
                    dispatch(formulaListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openFormulaFilterDialog = () => ({
    type: FORMULA_FILTER_DIALOG_OPEN
});

export const closeFormulaFilterDialog = () => ({
    type: FORMULA_FILTER_DIALOG_CLOSE
});

export const setFormulaFilteredData = (filter) => ({
    type: SET_FORMULA_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| EXPORT ||---------------------------------------------------------------
export const formulaExportPending = () => ({
    type: FORMULA_EXPORT_PENDING
});

export const formulaExportError = (errorMessage) => ({
    type: FORMULA_EXPORT_ERROR,
    payload: { errorMessage }
});

export const formulaExportErrorClear = () => ({
    type: FORMULA_EXPORT_ERROR_CLEAR
});

export const getformulaExport = (sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(formulaExportPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getformulaExport(accessToken, sortOrder, sortDirection, encodeFilters)
            .then((farmRecordList) => {
                dispatch(formulaExportErrorClear());
                return Promise.resolve(farmRecordList);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaExportError(message))
                }
                else {
                    dispatch(formulaExportError(":( Network Error"))
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| DETAILS ||----------------------------------------------//

export const formulaDetailPending = (id) => ({
    type: FORMULA_DETAIL_PENDING,
    payload: { id }
})
export const setFormulaDetails = (formulaDetails) => ({
    type: SET_FORMULA_DETAILS,
    payload: { formulaDetails }
})

export const clearFormulaDetails = () => ({
    type: CLEAR_FORMULA_DETAILS,
})

export const getFormulaDetails = (id, from) => (dispatch) => {
    dispatch(formulaDetailPending(id));
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getFormulaDetails(accessToken, id)
            .then((formulae) => {
                dispatch(setFormulaDetails(formulae));
                if (from === "form-configuration") {
                    dispatch(openFormulaEditDialog());
                }
                else {
                    dispatch(openFormulaEditDialog());
                }
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaListError(message));
                }
                else {
                    dispatch(formulaListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| CREATE ||-----------------------------------------------
export const openFormulaCreateDialog = () => ({
    type: FORMULA_CREATE_DIALOG_OPEN
});

export const closeFormulaCreateDialog = () => ({
    type: FORMULA_CREATE_DIALOG_CLOSE
});

export const setFormFields = (formFields) => ({
    type: SET_FORM_FIELDS,
    payload: { formFields }
});

export const clearFormFields = () => ({
    type: CLEAR_FORM_FIELDS,
});

export const formulaCreatePending = () => ({
    type: FORMULA_CREATE_PENDING
});

export const formulaCreateError = (errorMessage) => ({
    type: FORMULA_CREATE_ERROR,
    payload: { errorMessage }
});

export const formulaCreateErrorClear = () => ({
    type: FORMULA_CREATE_ERROR_CLEAR
});

export const getFormfields = (type) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.getFormfields(accessToken, type)
            .then((result) => {
                console.log("result: ", result);
                dispatch(setFormFields(result))
            })
            .catch((err) => {
                console.log(err)
            })
    })
}

export const formulaCreate = (dataToSend, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const value = trimmedValues(dataToSend);
    dispatch(formulaCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.formulaCreate(accessToken, value)
            .then(() => {
                dispatch(getFormulaList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(formulaCreateErrorClear());
                dispatch(closeFormulaCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Formula successfully created.',
                    variant: 'alert',
                    close: false
                }));
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaCreateError(message));
                }
                else {
                    dispatch(formulaCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openFormulaeEditDialog = () => ({
    type: FORMULA_EDIT_DIALOG_OPEN
});

export const closeFormulaeEditDialog = () => ({
    type: FORMULA_EDIT_DIALOG_CLOSE
});

export const formulaEditPending = () => ({
    type: FORMULA_EDIT_PENDING
});

export const formulaEditError = (errorMessage) => ({
    type: FORMULA_EDIT_ERROR,
    payload: { errorMessage }
});

export const formulaEditErrorClear = () => ({
    type: FORMULA_EDIT_ERROR_CLEAR
});

export const formulaEdit = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(formulaEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.formulaEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getFormulaList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(closeFormulaeEditDialog());
                dispatch(formulaEditErrorClear());
                dispatch(clearFormulaDetails());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Formula successfully updated.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaEditError(message));
                }
                else {
                    dispatch(formulaEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| DELETE ||---------------------------------------------------------------
export const openFormulaDeleteConfrimationDialog = () => ({
    type: FORMULA_DELETE_CONFIRMATION_OPEN,
});

export const closeFormulaDeleteConfrimationDialog = () => ({
    type: FORMULA_DELETE_CONFIRMATION_CLOSE,
});
export const setFormulaDeleteData = (selectedFormula) => ({
    type: SET_FORMULA_DELETE_DATA,
    payload: { selectedFormula }
});
export const formulaDeletePending = () => ({
    type: FORMULA_DELETE_PENDING,
});
export const formulaDeleteError = (errorMessage) => ({
    type: FORMULA_DELETE_ERROR,
    payload: { errorMessage }
});
export const formulaDeleteErrorClear = () => ({
    type: FORMULA_DELETE_ERROR_CLEAR,
});

export const deleteFormula = (Id, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    dispatch(formulaDeletePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.formulae.deleteFormula(accessToken, Id)
            .then(() => {
                dispatch(closeFormulaDeleteConfrimationDialog());
                dispatch(getFormulaList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(formulaDeleteErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Formula successfully deleted.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(formulaDeleteError(message));
                }
                else {
                    dispatch(formulaDeleteError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
